import { observable, IObservableArray } from "mobx";
import { EmptyId, EmptyESId, PositionLevel } from "./enums";
import { copy } from "../utils/data";

export class FilterEntry {
  @observable jobTitle: string;
  @observable jobId: string;
  @observable orgId: string;
  @observable locationId: string;
  @observable orgName: string;
  @observable categoryId: string;
  @observable level: PositionLevel;
  @observable employmentType: number;
  @observable ltE5: boolean;
  @observable ltE10: boolean;
  @observable ltE30: boolean;
  @observable ltE50: boolean;
  @observable canApply: boolean;
  @observable minAge: number;
  @observable minEd: number;
  @observable active: boolean;
  @observable keywords: Array<string>;
  @observable altTitles: Array<string>;

  constructor(fe?: FilterEntry) {
    this.jobTitle = this.orgName = "";
    this.jobId = this.orgId = this.locationId = EmptyId;
    this.keywords = new Array<string>();
    this.altTitles = new Array<string>();
    this.categoryId = EmptyESId;
    this.level = PositionLevel.NotSpecified;
    this.employmentType = this.minAge = this.minEd = 0; 
    this.ltE5 = this.ltE10 = this.ltE30 = this.ltE50 = this.canApply = false;
    this.active = true;
    if (fe) {
      copy(fe, this, ["keywords", "altTitles"]);
      (this.keywords as IObservableArray<string>).replace(fe.keywords);
      (this.altTitles as IObservableArray<string>).replace(fe.altTitles);
    }
  }
}

export class FilterRules {
  @observable position: string;
  @observable orgs: Array<string>;
  @observable categories: Array<string>
  @observable levels: Array<PositionLevel>;
  @observable empTypes: Array<number>;
  @observable distance: number;
  @observable zip: string;
  @observable canApply: boolean;
  @observable minEd: number;
  @observable minAge: number;

  constructor() {
    this.position = "";
    this.orgs = new Array<string>();
    this.categories = new Array<string>();
    this.levels = new Array<PositionLevel>();
    this.empTypes = new Array<number>();
    this.distance = 0;
    this.zip = "";
    this.canApply = false;
    this.minEd = 0;
    this.minAge = 999;
  }
}

export class FilterDisplay {
  @observable label: string;
  @observable value: any;
  @observable disabled: boolean;
  @observable checked: boolean;

  constructor(label: string, value: any) {
    this.label = label;
    this.value = value;
    this.disabled = true;
    this.checked = false;
  }
}


// WEBPACK FOOTER //
// ./src/models/filteroption.ts